import { render, staticRenderFns } from "./CreateSGDistributedLogs.vue?vue&type=template&id=27d31eeb&scoped=true"
import script from "./CreateSGDistributedLogs.vue?vue&type=script&lang=js"
export * from "./CreateSGDistributedLogs.vue?vue&type=script&lang=js"
import style0 from "./CreateSGDistributedLogs.vue?vue&type=style&index=0&id=27d31eeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d31eeb",
  null
  
)

export default component.exports